import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import dayjs from 'dayjs'
import { getData, sendData, sendDataBody, updateData, usuario } from '../../../resources';
import { Card, Button, Modal, InputNumber, Row, Col, message, DatePicker, Select } from 'antd';
import { Form, Input, TimePicker } from 'antd';
import { locale } from 'antd/lib/locale';
import { Link } from 'react-router-dom';
import HojaRegistroEmtBox from './hoja-registro-emt-components/hoja-registro-emt-box';

export default function HojaRegistroEMT() {

    const { state } = useLocation();
    const [form] = Form.useForm();

    const [patientData, setPatientData] = useState({})

    const [hojaEMT, setHojaEMT] = useState(null)

    useEffect(() => {
        const fetchPatientData = () => {
            const url = `/getuser/${state.visita.id_paciente}`
            console.log('Fetching patient data: ', url)
            getData(url).then(setPatientData)
        }
        fetchPatientData()

        const fetchHojaEMT = () => {
            const url = `hojas-emt/${state.visita._id}/${state.visita.id_paciente}`
            console.log('Fetching hoja EMT data initial: ', url,)
            getData(url).then((data) => {
                setHojaEMT(data);
                if (data && data.fecha) {
                    // Migrate legacy row1/row2/row3 format to protocolos array
                    const legacyRows = ['row1', 'row2', 'row3']
                        .filter(k => data[k])
                        .map(k => data[k]);
                    const protocolos = data.protocolos?.length > 0
                        ? data.protocolos
                        : legacyRows.length > 0 ? legacyRows : [{}];
                    const parsed = {
                        ...data,
                        protocolos,
                        fecha: {
                            evaluacion_1: data.fecha.evaluacion_1 ? dayjs(data.fecha.evaluacion_1) : null,
                            evaluacion_2: data.fecha.evaluacion_2 ? dayjs(data.fecha.evaluacion_2) : null,
                            evaluacion_3: data.fecha.evaluacion_3 ? dayjs(data.fecha.evaluacion_3) : null,
                            evaluacion_4: data.fecha.evaluacion_4 ? dayjs(data.fecha.evaluacion_4) : null,
                        }
                    };
                    form.setFieldsValue(parsed);
                } else {
                    form.setFieldsValue(data);
                }
            })
        }
        fetchHojaEMT()
    }, [])

    useEffect(() => {
        console.log('Hoja EMT: ', hojaEMT)
    }, [hojaEMT])

    const onFinishCreateHojaEMTM = (values) => {
        // console.log('paciente data ', patientData)
        const body = {
            ...values,
            id_paciente: state.visita.id_paciente,
            id_visita: state.visita._id,
        }

        hojaEMT ?
            updateData(`hojas-emt/update/${hojaEMT._id}`, body).then((res) => {
                message.success('Hoja de registro EMT actualizada');
                console.log('Hoja de registro EMT actualizada', res)
            })
            :
            sendDataBody('hojas-emt/add', body).then((res) => {
                message.success('Hoja de registro EMT agregada');
                setHojaEMT(res.data);
                console.log('Hoja de registro EMT agregada', res)
            })
    };

    const onFinishFailed = (errorInfo) => {
        message.warning('Revisa los campos');
        console.log('Failed:', errorInfo);
    };


    const boxInputMinWidth = "178px"

    const protocols = [
        { name: 'PHQ-9', key: 'phq9' },
        { name: 'GAD-7', key: 'gad7' },
        { name: 'DOCS', key: 'docs' },
        { name: 'THI', key: 'thi' },
        { name: 'PCL-5', key: 'pcl5' },
        { name: 'SARS', key: 'sars' },
        { name: 'Insomnio', key: 'insomnio' },
        { name: 'DOLOR', key: 'dolor' },
        { name: 'EMCA', key: 'emca' },
        { name: 'OWS', key: 'ows' },
        { name: 'CADSS', key: 'cadss' },
        { name: 'COLUMBIA', key: 'columbia' },
        { name: 'ESTRÉS', key: 'estres' },
    ]


    return (
        <div style={{ padding: '30px' }}>
            <Link to={{
                pathname: "/pacientes",
                state: { name: patientData.name }
            }}>
                ❮ Regresar
            </Link>
            <div style={{ height: '10px' }}></div>
            <h4>Hoja de registro EMT</h4>
            <h5>Estimulador Magnético Transcraneal</h5>
            {/* <p>{JSON.stringify(state)}</p> */}
            <br />
            <p className='datos'>Paciente: {patientData.name}</p>
            <p className='datos'>Medico tratante: {usuario.name}</p>
            <p className='datos'>Fecha: {new Date(state.visita.createdAt).toLocaleDateString()}</p>
            <p className='datos'>Hora: {new Date(state.visita.createdAt).toLocaleTimeString()}</p>

            <br />


            <Form
                form={form}
                name="add_hoja_enfermeria"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                // style={{ maxWidth: 600 }}
                initialValues={hojaEMT || {}}
                onFinish={onFinishCreateHojaEMTM}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout='vertical'
                size='small'
            >

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Peso (kg)" name="peso" rules={[{ required: true, message: 'Ingresa el peso' }]}>
                            <InputNumber style={{ minWidth: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Dosis" name="dosis" rules={[{ required: true, message: 'Ingresa la dosis' }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>


                {/* Table 1 */}
                <div className='fila'>
                    <span style={{ width: 100 }}>Primero</span>

                    <Form.Item label='Farmaco' name={['primero', 'farmaco']} rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label='Mañana' name={['primero', 'mañana']} rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label='Tarde' name={['primero', 'tarde']} rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item label='Noche' name={['primero', 'noche']} rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label='Tiempo en tx' name={['primero', 'tiempo_tx']} rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
                    <span style={{ width: 100, }}>Segundo</span>

                    <Form.Item name={['segundo', 'farmaco']} >
                        <Input />
                    </Form.Item>
                    <Form.Item name={['segundo', 'mañana']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['segundo', 'tarde']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['segundo', 'noche']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['segundo', 'tiempo_tx']}>
                        <Input />
                    </Form.Item>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
                    <span style={{ width: 100, }}>Tercero</span>

                    <Form.Item name={['tercero', 'farmaco']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['tercero', 'mañana']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['tercero', 'tarde']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['tercero', 'noche']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['tercero', 'tiempo_tx']}>
                        <Input />
                    </Form.Item>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
                    <span style={{ width: 100, }}>Cuarto</span>

                    <Form.Item name={['cuarto', 'farmaco']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['cuarto', 'mañana']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['cuarto', 'tarde']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['cuarto', 'noche']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['cuarto', 'tiempo_tx']}>
                        <Input />
                    </Form.Item>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
                    <span style={{ width: 100, }}>Quinto</span>

                    <Form.Item name={['quinto', 'farmaco']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['quinto', 'mañana']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['quinto', 'tarde']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['quinto', 'noche']}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['quinto', 'tiempo_tx']}>
                        <Input />
                    </Form.Item>
                </div>


                <br />
                <br />



                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="NASION- INION (cm)"
                            name="nasion_inion"
                            rules={[{ required: true, message: 'Ingresa el nasion-inion' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="AURIQCULAR IZQ. - AURICULAR DER (cm)"
                            name="auricular_izq_auricular_der"
                            rules={[{ required: true, message: 'Ingresa el auricular izq-auricular der' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>



                <br />
                <br />

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Circunferencia"
                            name="circunferencia"
                            rules={[{ required: true, message: 'Ingresa la circunferencia' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Gorro a (cm) de nasion"
                            name="gorro_a_nasion"
                            rules={[{ required: true, message: 'Ingresa la gorro a nasion' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>




                {/* Table 2 - HREMTT2 */}
                <div className='fila'>
                    {/* This mandatory */}
                    <span style={{ minWidth: boxInputMinWidth }}>PROTOCOLO \ FECHA</span>
                    <Form.Item label='Evaluacion 1' name={['fecha', 'evaluacion_1']}>
                        <DatePicker style={{ minWidth: boxInputMinWidth }} />
                    </Form.Item>
                    <Form.Item label='Evaluacion 2' name={['fecha', 'evaluacion_2']}>
                        <DatePicker style={{ minWidth: boxInputMinWidth }} />
                    </Form.Item>
                    <Form.Item label='Evaluacion 3' name={['fecha', 'evaluacion_3']}>
                        <DatePicker style={{ minWidth: boxInputMinWidth }} />
                    </Form.Item>
                    <Form.Item label='Evaluacion 4' name={['fecha', 'evaluacion_4']}>
                        <DatePicker style={{ minWidth: boxInputMinWidth }} />
                    </Form.Item>
                </div>

                <Form.List name="protocolos" initialValue={[{}]}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((field) => (
                                <div key={field.key} style={{ display: 'flex', flexDirection: 'row', columnGap: '10px', alignItems: 'flex-end' }}>
                                    <Form.Item name={[field.name, 'protocolo']}>
                                        <Select
                                            placeholder='Selecciona un protocolo'
                                            style={{ minWidth: boxInputMinWidth }}
                                            options={protocols.map(protocol => ({ label: protocol.name, value: protocol.key }))}
                                        />
                                    </Form.Item>
                                    <Form.Item name={[field.name, 'evaluacion_1']}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item name={[field.name, 'evaluacion_2']}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item name={[field.name, 'evaluacion_3']}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item name={[field.name, 'evaluacion_4']}>
                                        <Input />
                                    </Form.Item>
                                    {fields.length > 1 && (
                                        <Button
                                            danger
                                            size='small'
                                            style={{ marginBottom: 24 }}
                                            onClick={() => remove(field.name)}
                                        >
                                            −
                                        </Button>
                                    )}
                                </div>
                            ))}
                            <Button size='small' style={{ marginBottom: 16 }} onClick={() => add()}>
                                + Agregar fila
                            </Button>
                        </>
                    )}
                </Form.List>




                <Form.Item label="Observaciones del aplicador" name="observaciones" rules={[{ required: true, message: 'Ingresa las observaciones' }]}>
                    <Input.TextArea />
                </Form.Item>


                <Form.Item>
                    <Button type="primary" size='middle' htmlType="submit">
                        Guardar
                    </Button>
                </Form.Item>
            </Form>


            <HojaRegistroEmtBox idVisita={state.visita._id} idPaciente={state.visita.id_paciente} />


        </div>
    )
}
